import React from 'react';
import { KompisKeyboardInjector } from '@inter-ikea-kompis/react-components';
import { getLocale } from 'i18n/i18nUtils';
import { usesVirtualKeyboard } from 'utils/platform';
import { useIntl } from 'react-intl';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

interface Props {
  children: React.ReactNode;
}

const VirtualKeyboardProvider = ({ children }: Props) => {
  const locale = getLocale();
  const { formatMessage } = useIntl();

  const doneButtonLabel = formatMessage({ id: 'kompis.popUpClose' });

  return usesVirtualKeyboard() ? (
    <KompisKeyboardInjector
      theme={SkapaTheme}
      locale={locale}
      doneButtonLabel={doneButtonLabel}
      className={'virtualKeyboard'}
    >
      {children}
    </KompisKeyboardInjector>
  ) : (
    <>{children}</>
  );
};

export default VirtualKeyboardProvider;
